// Briefing doc:
// https://docs.google.com/document/d/1BTp18c5o5Qiyvx5Lb2PAS0MzcHRQDnx9_HDC8M8Te_8/edit?ts=5a8d42c1


// Video plays
export function dataLayerVideo(id) {
    dataLayer.push({
        event: 'video',
        eventaction: 'play',
        videoUrl: id
    });
}

// Popup open
export function dataLayerPopup(popupId) {
    dataLayer.push({
        event: 'popup',
        eventaction: 'open',
        eventlabel: popupId
    });
}

// Button clicks
export function handleDataLayerButtonClicks() {
    const buttons = document.querySelectorAll('.btn');

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            if (
                // not these buttons, they have their own stuff going on
                (!button.classList.contains('js-modal-handle')) &&
                (!button.classList.contains('js-programme-detail-btn')) &&
                (!button.classList.contains('js-checkout-submit')) &&
                (button.type !== 'submit')
            ) {
                dataLayer.push({
                    event: 'button',
                    buttonText: button.querySelector('span').innerText.toLowerCase()
                });
            }
        });
    });
}

// Open content with arrow (FAQ-style)
export function dataLayerContentExtention(title) {
    dataLayer.push({
        event: 'event',
        eventcategory: 'contentExtention',
        eventaction: 'click',
        content: title
    });
}

// Product impressions
export function dataLayerProductImpressions() {
    const productImpression = document.querySelectorAll('.js-product-impression');
    const impressionsData = [];

    for (let i = 0; i < productImpression.length; i++) {
        const programmeDetailBtn = productImpression[i].querySelector('.js-programme-detail-btn');

        const impressionData = {
            name: programmeDetailBtn.dataset.programmeName,
            id: programmeDetailBtn.dataset.programmeId,
            price: programmeDetailBtn.dataset.programmePrice,
            promoprice: programmeDetailBtn.dataset.programmePromoPrice,
            brand: 'Will',
            category: programmeDetailBtn.dataset.programmeCategory
        };

        impressionsData.push(impressionData);
    }

    dataLayer.push({
        ecommerce: {
            currencyCode: 'EUR',
            impressions: impressionsData
        }
    });
}

// Product detail click
export function handleDataLayerProductClick() {
    const programmeDetailBtn = document.querySelectorAll('.js-programme-detail-btn');

    programmeDetailBtn.forEach((each) => {
        each.addEventListener('click', () => {
            dataLayer.push({
                event: 'productClick',
                ecommerce: {
                    click: {
                        actionField: {
                            list: 'Product details'
                        },
                        products: [{
                            name: each.dataset.programmeName,
                            id: each.dataset.programmeId,
                            price: each.dataset.programmePrice,
                            promoprice: each.dataset.programmePromoPrice,
                            brand: 'Will',
                            cat: each.dataset.programmeCategory
                        }]
                    }
                }
            });
        });
    });
}

// Product detail page
function dataLayerProductDetailPage() {
    const programmeDetailPageEl = document.querySelector('.js-programme-detail-page');

    if (programmeDetailPageEl) {
        dataLayer.push({
            ecommerce: {
                detail: {
                    actionField: {
                        list: 'Programme detail page'
                    },
                    products: [{
                        name: programmeDetailPageEl.dataset.programmeName,
                        id: programmeDetailPageEl.dataset.programmeId,
                        price: programmeDetailPageEl.dataset.programmePrice,
                        promoprice: programmeDetailPageEl.dataset.programmePromoPrice,
                        brand: 'Will',
                        cat: programmeDetailPageEl.dataset.programmeCategory
                    }]
                }
            }
        });
    }
}

// Checkout step: Payment Confirmation
function dataLayerPaymentConfirmation() {
    const checkoutSuccessPageEl = document.querySelector('.js-checkout-success');

    if (checkoutSuccessPageEl) {
        dataLayer.push({
            event: 'checkout',
            ecommerce: {
                checkout: {
                    actionField: {
                        step: 'Betaling bevestiging',
                        option: checkoutSuccessPageEl.dataset.paymentType
                    },
                    products: [{
                        name: checkoutSuccessPageEl.dataset.programmeName,
                        id: checkoutSuccessPageEl.dataset.programmeId,
                        price: checkoutSuccessPageEl.dataset.programmePrice,
                        brand: 'Will',
                        category: checkoutSuccessPageEl.dataset.programmeCategory,
                        quantity: 1
                    }]
                }
            }
        });

        dataLayer.push({
            event: 'purchase',
            ecommerce: {
                purchase: {
                    actionField: {
                        id: checkoutSuccessPageEl.dataset.paymentId,
                        revenue: checkoutSuccessPageEl.dataset.programmePrice,
                        transactionTotal:  checkoutSuccessPageEl.dataset.orderPrice,
                        transactionId:  checkoutSuccessPageEl.dataset.orderId,
                    },
                    products: [{
                        name: checkoutSuccessPageEl.dataset.programmeName,
                        id: checkoutSuccessPageEl.dataset.programmeId,
                        price: checkoutSuccessPageEl.dataset.programmePrice,
                        brand: 'Will',
                        category: checkoutSuccessPageEl.dataset.programmeCategory,
                        quantity: 1,
                        coupon: checkoutSuccessPageEl.dataset.paymentPromocode
                    }]
                }
            }
        });

        dataLayer.push({
          'refcode': checkoutSuccessPageEl.dataset.refCode,
        });
    }
}

// Promocode submit
export function handleDataLayerPromocodeSubmit() {
    const promoCodeWrapper = document.querySelector('.js-promocode-form-wrapper');

    if (promoCodeWrapper) {
        const promoCodeValue = promoCodeWrapper.querySelector('.form-control').value;

        dataLayer.push({
            event: 'promotionClick',
            ecommerce: {
                promoClick: {
                    promotions: [{
                        id: promoCodeValue,
                        name: promoCodeWrapper.dataset.programmeName
                    }]
                }
            }
        });
    }
}


function handleClicks() {
    const links = document.querySelectorAll('a[href]:not(.js-videolink-play-link)');
    const mailtoLinks = document.querySelectorAll('a[href^=mailto]');
    const submitButton = document.querySelectorAll('*[type=submit]');
    const downloadLink = document.querySelectorAll('.js-download-link');
    const checkbox = document.querySelectorAll('input[type="checkbox"]');
    const checkoutSubmitBtn = document.querySelector('.js-checkout-submit');
    const paymentChoices = document.querySelectorAll('.js-payment-choices input');

    // Mailto
    mailtoLinks.forEach((each) => {
        each.addEventListener('click', () => {
            dataLayer.push({
                event: 'contact',
                eventaction: 'mail',
                mailUrl: each.href.replace(/^mailto:([^?]+).*/, '$1')
            });
        });
    });

    // Outgoing links
    links.forEach((each) => {
        each.addEventListener('click', (e) => {
            const href = e.currentTarget.href;

            if (
                (e.currentTarget.host !== window.location.host) &&
                (!href.match(/^mailto:/i))
            ) {
                dataLayer.push({
                    event: 'outgoing',
                    linkUrl: href
                });
            }
        });
    });

    // Form submit
    submitButton.forEach((each) => {
        each.addEventListener('click', (e) => {
            const formUrl = e.currentTarget.closest('form').action;
            const pathArray = formUrl.split('/');
            const secondLevelLocation = pathArray.splice(4);
            const formName = secondLevelLocation.join('/');

            if (
                // not these submit buttons, they have their own stuff going on
                (!each.classList.contains('js-checkout-submit')) &&
                (!each.classList.contains('js-promo-submit'))
            ) {
                dataLayer.push({
                    event: 'form',
                    eventaction: 'submit',
                    eventlabel: formName
                });
            }
        });
    });

    // Download
    downloadLink.forEach((each) => {
        each.addEventListener('click', () => {
            dataLayer.push({
                event: 'download',
                downloadUrl: each.href
            });
        });
    });

    // Checkboxes
    checkbox.forEach((each) => {
        each.addEventListener('click', () => {
            const label = each.nextSibling.innerText;

            if (each.checked) {
                dataLayer.push({
                    event: 'event',
                    eventcategory: 'box',
                    eventaction: 'select',
                    box: label
                });
            } else {
                dataLayer.push({
                    event: 'event',
                    eventcategory: 'box',
                    eventaction: 'deselect',
                    box: label
                });
            }
        });
    });

    // Checkout step: Go to payment (Molly)
    if (checkoutSubmitBtn) {
        checkoutSubmitBtn.addEventListener('click', () => {
            let paymentChoiceData;

            paymentChoices.forEach((paymentChoice) => {
                if (paymentChoice.checked) {
                    paymentChoiceData = paymentChoice.dataset.paymentType;
                }
            });

            dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    checkout: {
                        actionField: {
                            step: 'Go to betaling website',
                            option: paymentChoiceData
                        },
                        products: [{
                            name: checkoutSubmitBtn.dataset.programmeName,
                            id: checkoutSubmitBtn.dataset.programmeId,
                            price: checkoutSubmitBtn.dataset.programmePrice,
                            brand: 'Will',
                            category: checkoutSubmitBtn.dataset.programmeCategory,
                            quantity: 1
                        }]
                    }
                }
            });
        });
    }
}

export default function initDataLayers() {
    handleClicks();
    handleDataLayerButtonClicks();
    handleDataLayerProductClick();

    dataLayerProductDetailPage();
    dataLayerPaymentConfirmation();
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/dataLayers.js